import {
  RRIBatchOption,
  RRICustomBatchOptionSettings,
  RRIDeleteBatchOptionSettings,
  RRIDownloadBatchOptionSettings,
  RRIUpdateBatchOptionSettings,
} from '../interfaces/table/batch-options.interface';

export type RRBatchOption<T, R> =
  | RRIBatchOption<RRIDeleteBatchOptionSettings<T>>
  | RRIBatchOption<RRIDownloadBatchOptionSettings<T, R>>
  | RRIBatchOption<RRIUpdateBatchOptionSettings<T>>
  | RRIBatchOption<RRICustomBatchOptionSettings<T>>
  | RRIBatchOption<RRICustomBatchOptionSettings<T>[]>;
